import { Row } from 'antd'
import { PURCHASE_ORDER } from '@Orders/constants'
import { getPaymentType } from '@Orders/OrderDetailsPage/logic'
import ShipTo from '@Orders/OrderDetailsPage/OrderDetailHeaderAndFooter/ShipTo'
import { salesOrder_salesOrder_paymentDetails as SalesOrderPaymentDetailsType } from '@Orders/OrderDetailsPage/Queries/__generated__/salesOrder'
import { PROVISIONED_UI_FLAGS } from '@Builder/QuoteDetailPage/logic'

import Box from '~/core/Box'
import Text from '~/core/Text'
import { useFlagEnabled } from '~/lib/isFlagEnabled'

import { SalesOrderInfo } from './SalesOrderInfo'

interface OrderDetailsPropsType {
    paymentDetails: SalesOrderPaymentDetailsType | null
    isImOrder: boolean
    quoteName?: string | null
    salesOrder: any
}

const OrderDetails = ({
    paymentDetails,
    quoteName,
    salesOrder,
}: OrderDetailsPropsType) => {
    const {
        billingAddress,
        creditCardLast4,
        paidBy, // to be used if there is a user record for the purchasing entity
        paidByDisplayName: rawPurchaserDisplayName, // to be used if there is no user record for the purchasing entity
        paymentType,
        purchaseOrderNumber,
    } = paymentDetails || {}

    const purchaserDisplayName = paidBy?.displayName || rawPurchaserDisplayName
    const paymentTypeText = getPaymentType({
        paymentType,
        creditCardLast4,
    })

    const isCpqFlagV2Enabled = useFlagEnabled(
        PROVISIONED_UI_FLAGS.UI_CPQ_QUOTES_INTEGRATION_V2,
    )

    return (
        <Row gutter={[0, 16]}>
            {isCpqFlagV2Enabled && salesOrder?.quotePdfUrl ? null : (
                <Box
                    data-test-target="order-details-shipping-address"
                    paddingRight="25px"
                    width="250px"
                >
                    <SalesOrderInfo title="Shipping address">
                        <ShipTo postalAddress={billingAddress || null} />
                    </SalesOrderInfo>
                </Box>
            )}
            {quoteName && (
                <Box
                    data-test-target="order-details-quote-name"
                    width="250px"
                    paddingRight="25px"
                >
                    <SalesOrderInfo title="Reference quote #">
                        {quoteName}
                    </SalesOrderInfo>
                </Box>
            )}
            <Box
                data-test-target="order-details-payment-method"
                paddingRight="25px"
                width="250px"
            >
                <SalesOrderInfo title=" Payment method">
                    Paid with{' '}
                    <Text data-test-target="order-details-payment-method-cardnos">
                        {paymentTypeText}
                    </Text>
                    {paymentType == PURCHASE_ORDER && (
                        <p>{purchaseOrderNumber}</p>
                    )}
                </SalesOrderInfo>
            </Box>
            <Box
                data-test-target="order-details-payment-orderpaidby"
                width="250px"
            >
                <SalesOrderInfo title="Paid by">
                    {purchaserDisplayName}
                </SalesOrderInfo>
            </Box>
        </Row>
    )
}

export default OrderDetails
